import { useQuery } from "@apollo/client/react";
import useAuth from "./useAuth";
import { LINKABLE_EXTERNAL_RECORDS_QUERY } from "src/constants/graphql/queries";

export default function useHasEnabledIntegration(project) {
  const { user } = useAuth();
  const enabled = (user?.company?.enabledIntegrationProviders || []).length > 0;
  const projectId = project?.id;

  const { data, loading } = useQuery(LINKABLE_EXTERNAL_RECORDS_QUERY, {
    variables: { linkableType: "Project", linkableId: projectId },
    skip: !enabled || !projectId,
  });

  const projectLinked = (data?.linkableExternalRecords || []).length > 0;

  return {
    hasIntegration: Boolean(enabled && projectId && projectLinked),
    loading: Boolean(enabled && projectId && loading),
  };
}
